import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  signal,
  viewChild
} from '@angular/core';

import { ContactDetails } from '@amfam/shared/utility/contact-us/lib/models/contact-us.model';
import { CopyService } from '@amfam/shared/utility/shared-services/lib/copy/copy.service';

@Component({
  selector: 'ds-contact-details',
  templateUrl: './ds-contact-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./ds-contact-details.component.scss'],
  host: {
    '(document:click)': 'onDocumentClick($event)'
  }
})
export class ContactDetailsComponent {
  private copy = inject(CopyService);

  // Reference to the container element, used to detect outside clicks
  private popupContainer = viewChild<ElementRef>('popupContainer');

  readonly contactDetails = input.required<ContactDetails>();

  readonly showPopup = signal(false);
  readonly contact = this.copy.getCopy('shared.contactUsText');

  // Listen for clicks on the whole document
  onDocumentClick(event: MouseEvent) {
    const container = this.popupContainer()?.nativeElement;
    // If the popup is open and the click is outside the component, close it
    if (this.showPopup() && container && !container.contains(event.target)) {
      this.showPopup.set(false);
    }
  }

  // Toggle the popup visibility
  togglePopup() {
    this.showPopup.update(showPopup => !showPopup);
  }

  // Close the popup (used by the 'X' button)
  closePopup() {
    this.showPopup.set(false);
  }
}
